import React from "react";
import { useSelector } from "react-redux";
import { OutlineButton, PrimaryButton } from "../Buttons";
import { buildPermissionContext } from "../../util/permissions";

/**
 * ExportCsvBtn - Button for exporting data to CSV
 *
 * @param {Object} props
 * @param {function} props.handleExportCSV - Export handler
 * @param {string} props.buttonLabel - Button label (default: "Export CSV")
 *
 * @example
 * <ExportCsvBtn handleExportCSV={handleExport} />
 * <ExportCsvBtn handleExportCSV={handleExport} buttonLabel="Download CSV" />
 */
const ExportCsvBtn = ({
  handleExportCSV,
  buttonLabel = "Export CSV",
  whiteVariant = false,
  size = "md",
  disabled = false,
  ...buttonProps
}) => {
  const authUser = useSelector((state) => state.auth.user);
  const permissionCtx = buildPermissionContext(authUser);
  const canEdit = permissionCtx.permissions?.Edit === true && !disabled;

  if (whiteVariant) {
    return (
      <OutlineButton
        onClick={canEdit && !disabled ? handleExportCSV : undefined}
        size={size}
        disabled={!canEdit || disabled}
        style={{
          backgroundColor: "#ffffff",
          color: "#007bff",
          borderColor: "#007bff",
          opacity: canEdit && !disabled ? 1 : 0.5,
        }}
        {...buttonProps}
      >
        {buttonLabel}
      </OutlineButton>
    );
  }

  return (
    <PrimaryButton
      onClick={canEdit && !disabled ? handleExportCSV : undefined}
      size={size}
      disabled={!canEdit || disabled}
      style={{
        opacity: canEdit && !disabled ? 1 : 0.5,
        cursor: canEdit && !disabled ? "pointer" : "not-allowed",
        ...buttonProps.style,
      }}
      {...buttonProps}
    >
      {buttonLabel}
    </PrimaryButton>
  );
};

export default ExportCsvBtn;
